"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CEOReviewHeroBlock = void 0;
const spa_core_1 = require("@episerver/spa-core");
const Link_1 = __importStar(require("../Common/Link"));
const react_1 = __importDefault(require("react"));
const CEOReviewHeroBlock = (props) => {
    var _a, _b, _c, _d, _e;
    const bgComponent = ((_a = props.data.backgroundImage) === null || _a === void 0 ? void 0 : _a.value) ?
        react_1.default.createElement(spa_core_1.Components.EpiserverContent, { contentLink: props.data.backgroundImage.value, className: "d-cover", expandedValue: props.data.backgroundImage.expandedValue }) :
        null;
    const target = ((_b = props.data.linkTarget) === null || _b === void 0 ? void 0 : _b.value) === '_blank' ? Link_1.LinkTarget.New_window : Link_1.LinkTarget.Current_window;
    return react_1.default.createElement("div", Object.assign({ className: 'row mb-9 ceohero', "data-glenabled": (_c = props.data.enableGlossary) === null || _c === void 0 ? void 0 : _c.value }, (((_d = props.data.blockLanguage) === null || _d === void 0 ? void 0 : _d.value) !== '' ? { lang: (_e = props.data.blockLanguage) === null || _e === void 0 ? void 0 : _e.value } : null)),
        react_1.default.createElement("div", { className: 'col-12 col-sm-7 text pt-7 pt-sm-0 d-flex flex-column justify-content-center order-2 order-sm-1' },
            react_1.default.createElement("h1", { className: 'h2-alt mt-sm-8 mb-9 d-none d-sm-block' },
                react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: 'title' })),
            react_1.default.createElement("p", { className: 'w80 mb-6 mb-sm-8' },
                react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: 'desc' })),
            react_1.default.createElement(Link_1.default, { href: props.data.link.value, target: target, title: props.data.linkText.value, type: Link_1.LinkType.Primary_button, icon_class: 'icon-arrow-right-tail' })),
        react_1.default.createElement("div", { className: 'col-12 col-sm-5 ps-sm-9 ceoimg order-1 order-sm-2' },
            react_1.default.createElement("h1", { className: 'h2-alt mb-7 d-block d-sm-none mt-9 ' },
                react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: 'title' })),
            bgComponent));
};
exports.CEOReviewHeroBlock = CEOReviewHeroBlock;
exports.default = exports.CEOReviewHeroBlock;
